// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.10.2 (commit 58d2a40718c59535fd5c267e836d473298eb84d5).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AddOperatorReducer from "./add_operator_reducer";
import AddServiceGrantReducer from "./add_service_grant_reducer";
import EditIncidentReducer from "./edit_incident_reducer";
import EndMaintenanceReducer from "./end_maintenance_reducer";
import IngestAlertReducer from "./ingest_alert_reducer";
import OpenIncidentReducer from "./open_incident_reducer";
import PruneNowReducer from "./prune_now_reducer";
import RecomputeReducer from "./recompute_reducer";
import RecordDeployReducer from "./record_deploy_reducer";
import RemoveComponentReducer from "./remove_component_reducer";
import RemoveOperatorReducer from "./remove_operator_reducer";
import RemoveServiceGrantReducer from "./remove_service_grant_reducer";
import ResolveIncidentReducer from "./resolve_incident_reducer";
import RestoreIncidentReducer from "./restore_incident_reducer";
import RestoreMaintenanceReducer from "./restore_maintenance_reducer";
import RestoreUptimeDaysReducer from "./restore_uptime_days_reducer";
import ScheduleMaintenanceReducer from "./schedule_maintenance_reducer";
import SetAlertMapReducer from "./set_alert_map_reducer";
import SetOverrideReducer from "./set_override_reducer";
import SetSettingReducer from "./set_setting_reducer";
import StartMaintenanceReducer from "./start_maintenance_reducer";
import UpdateIncidentReducer from "./update_incident_reducer";
import UpsertComponentReducer from "./upsert_component_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import AlertMapRow from "./alert_map_table";
import ComponentRow from "./component_table";
import ComponentStateRow from "./component_state_table";
import IncidentRow from "./incident_table";
import IncidentUpdateRow from "./incident_update_table";
import MaintenanceRow from "./maintenance_table";
import OperatorRow from "./operator_table";
import OverallRow from "./overall_table";
import ProbeResultRow from "./probe_result_table";
import SettingsRow from "./settings_table";
import UptimeDayRow from "./uptime_day_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  alertMap: __table({
    name: 'alert_map',
    indexes: [
      { accessor: 'alertname', name: 'alert_map_alertname_idx_btree', algorithm: 'btree', columns: [
        'alertname',
      ] },
    ],
    constraints: [
      { name: 'alert_map_alertname_key', constraint: 'unique', columns: ['alertname'] },
    ],
  }, AlertMapRow),
  component: __table({
    name: 'component',
    indexes: [
      { accessor: 'key', name: 'component_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'component_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, ComponentRow),
  componentState: __table({
    name: 'component_state',
    indexes: [
      { accessor: 'component_key', name: 'component_state_component_key_idx_btree', algorithm: 'btree', columns: [
        'componentKey',
      ] },
    ],
    constraints: [
      { name: 'component_state_component_key_key', constraint: 'unique', columns: ['componentKey'] },
    ],
  }, ComponentStateRow),
  incident: __table({
    name: 'incident',
    indexes: [
      { accessor: 'alert_group_key', name: 'incident_alert_group_key_idx_btree', algorithm: 'btree', columns: [
        'alertGroupKey',
      ] },
      { accessor: 'id', name: 'incident_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'incident_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, IncidentRow),
  incidentUpdate: __table({
    name: 'incident_update',
    indexes: [
      { accessor: 'id', name: 'incident_update_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'incident_id', name: 'incident_update_incident_id_idx_btree', algorithm: 'btree', columns: [
        'incidentId',
      ] },
    ],
    constraints: [
      { name: 'incident_update_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, IncidentUpdateRow),
  maintenance: __table({
    name: 'maintenance',
    indexes: [
      { accessor: 'id', name: 'maintenance_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'run_id', name: 'maintenance_run_id_idx_btree', algorithm: 'btree', columns: [
        'runId',
      ] },
    ],
    constraints: [
      { name: 'maintenance_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, MaintenanceRow),
  operator: __table({
    name: 'operator',
    indexes: [
      { accessor: 'identity', name: 'operator_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'operator_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, OperatorRow),
  overall: __table({
    name: 'overall',
    indexes: [
      { accessor: 'key', name: 'overall_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'overall_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, OverallRow),
  probeResult: __table({
    name: 'probe_result',
    indexes: [
      { accessor: 'at', name: 'probe_result_at_idx_btree', algorithm: 'btree', columns: [
        'at',
      ] },
      { accessor: 'component_key', name: 'probe_result_component_key_idx_btree', algorithm: 'btree', columns: [
        'componentKey',
      ] },
      { accessor: 'id', name: 'probe_result_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'probe_result_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ProbeResultRow),
  settings: __table({
    name: 'settings',
    indexes: [
      { accessor: 'key', name: 'settings_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'settings_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, SettingsRow),
  uptimeDay: __table({
    name: 'uptime_day',
    indexes: [
      { accessor: 'component_key', name: 'uptime_day_component_key_idx_btree', algorithm: 'btree', columns: [
        'componentKey',
      ] },
      { accessor: 'id', name: 'uptime_day_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'uptime_day_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, UptimeDayRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("add_operator", AddOperatorReducer),
  __reducerSchema("add_service_grant", AddServiceGrantReducer),
  __reducerSchema("edit_incident", EditIncidentReducer),
  __reducerSchema("end_maintenance", EndMaintenanceReducer),
  __reducerSchema("ingest_alert", IngestAlertReducer),
  __reducerSchema("open_incident", OpenIncidentReducer),
  __reducerSchema("prune_now", PruneNowReducer),
  __reducerSchema("recompute", RecomputeReducer),
  __reducerSchema("record_deploy", RecordDeployReducer),
  __reducerSchema("remove_component", RemoveComponentReducer),
  __reducerSchema("remove_operator", RemoveOperatorReducer),
  __reducerSchema("remove_service_grant", RemoveServiceGrantReducer),
  __reducerSchema("resolve_incident", ResolveIncidentReducer),
  __reducerSchema("restore_incident", RestoreIncidentReducer),
  __reducerSchema("restore_maintenance", RestoreMaintenanceReducer),
  __reducerSchema("restore_uptime_days", RestoreUptimeDaysReducer),
  __reducerSchema("schedule_maintenance", ScheduleMaintenanceReducer),
  __reducerSchema("set_alert_map", SetAlertMapReducer),
  __reducerSchema("set_override", SetOverrideReducer),
  __reducerSchema("set_setting", SetSettingReducer),
  __reducerSchema("start_maintenance", StartMaintenanceReducer),
  __reducerSchema("update_incident", UpdateIncidentReducer),
  __reducerSchema("upsert_component", UpsertComponentReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

type __SchemaWithTableAccessorAliases = Omit<typeof tablesSchema.schemaType, "tables"> & {
  tables: typeof tablesSchema.schemaType.tables & {
    /** @deprecated Use `alertMap` instead. This alias will be removed in the next major version. */
    readonly "alert_map": Omit<typeof tablesSchema.schemaType.tables["alertMap"], "accessorName"> & { readonly accessorName: "alert_map" };
    /** @deprecated Use `componentState` instead. This alias will be removed in the next major version. */
    readonly "component_state": Omit<typeof tablesSchema.schemaType.tables["componentState"], "accessorName"> & { readonly accessorName: "component_state" };
    /** @deprecated Use `incidentUpdate` instead. This alias will be removed in the next major version. */
    readonly "incident_update": Omit<typeof tablesSchema.schemaType.tables["incidentUpdate"], "accessorName"> & { readonly accessorName: "incident_update" };
    /** @deprecated Use `probeResult` instead. This alias will be removed in the next major version. */
    readonly "probe_result": Omit<typeof tablesSchema.schemaType.tables["probeResult"], "accessorName"> & { readonly accessorName: "probe_result" };
    /** @deprecated Use `uptimeDay` instead. This alias will be removed in the next major version. */
    readonly "uptime_day": Omit<typeof tablesSchema.schemaType.tables["uptimeDay"], "accessorName"> & { readonly accessorName: "uptime_day" };
  };
};

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.10.2" as const,
  },
  tables: tablesSchema.schemaType.tables as __SchemaWithTableAccessorAliases["tables"],
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  __SchemaWithTableAccessorAliases,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

const tableAccessorAliases = {
  "alert_map": "alertMap",
  "component_state": "componentState",
  "incident_update": "incidentUpdate",
  "probe_result": "probeResult",
  "uptime_day": "uptimeDay",
} as const;

function __withTableAccessorAliases<T extends object>(target: T, freeze = false): T {
  const out = Object.create(Object.getPrototypeOf(target)) as T & Record<string, unknown>;
  Object.defineProperties(out, Object.getOwnPropertyDescriptors(target));
  for (const [deprecatedAccessor, targetAccessor] of Object.entries(tableAccessorAliases)) {
    if (deprecatedAccessor in out) {
      continue;
    }
    Object.defineProperty(out, deprecatedAccessor, {
      enumerable: true,
      configurable: false,
      get: () => out[targetAccessor],
    });
  }
  return freeze ? Object.freeze(out) : out;
}

type __DbViewBase = __DbConnectionImpl<typeof REMOTE_MODULE>["db"];
export type DbView = __DbViewBase & {
  /** @deprecated Use `alertMap` instead. This alias will be removed in the next major version. */
  readonly "alert_map": __DbViewBase["alertMap"];
  /** @deprecated Use `componentState` instead. This alias will be removed in the next major version. */
  readonly "component_state": __DbViewBase["componentState"];
  /** @deprecated Use `incidentUpdate` instead. This alias will be removed in the next major version. */
  readonly "incident_update": __DbViewBase["incidentUpdate"];
  /** @deprecated Use `probeResult` instead. This alias will be removed in the next major version. */
  readonly "probe_result": __DbViewBase["probeResult"];
  /** @deprecated Use `uptimeDay` instead. This alias will be removed in the next major version. */
  readonly "uptime_day": __DbViewBase["uptimeDay"];
};

type __TablesBase = __QueryBuilder<typeof tablesSchema.schemaType>;
export type Tables = __TablesBase & {
  /** @deprecated Use `alertMap` instead. This alias will be removed in the next major version. */
  readonly "alert_map": __TablesBase["alertMap"];
  /** @deprecated Use `componentState` instead. This alias will be removed in the next major version. */
  readonly "component_state": __TablesBase["componentState"];
  /** @deprecated Use `incidentUpdate` instead. This alias will be removed in the next major version. */
  readonly "incident_update": __TablesBase["incidentUpdate"];
  /** @deprecated Use `probeResult` instead. This alias will be removed in the next major version. */
  readonly "probe_result": __TablesBase["probeResult"];
  /** @deprecated Use `uptimeDay` instead. This alias will be removed in the next major version. */
  readonly "uptime_day": __TablesBase["uptimeDay"];
};

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
const tablesBase: __TablesBase = __makeQueryBuilder(tablesSchema.schemaType);
export const tables: Tables = __withTableAccessorAliases(tablesBase, true) as Tables;

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = Omit<__EventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = Omit<__ReducerEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = Omit<__SubscriptionEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for error events. */
export type ErrorContext = Omit<__ErrorContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  declare db: DbView;

  constructor(config: __DbConnectionConfig<typeof REMOTE_MODULE>) {
    super(config);
    this.db = __withTableAccessorAliases(this.db) as DbView;
  }

  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

